import { HTMLAttributes } from "react";

export default function ShadCN(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2332_1851)">
        <path
          d="M44.4381 23.568L23.5681 44.438C23.2084 44.8356 23.0153 45.3563 23.0287 45.8923C23.0422 46.4284 23.2611 46.9387 23.6402 47.3179C24.0194 47.697 24.5297 47.9159 25.0657 47.9294C25.6018 47.9428 26.1224 47.7497 26.5201 47.39L47.3901 26.52C47.7498 26.1224 47.9429 25.6017 47.9294 25.0657C47.916 24.5296 47.6971 24.0193 47.318 23.6401C46.9388 23.261 46.4285 23.0421 45.8924 23.0286C45.3564 23.0152 44.8357 23.2083 44.4381 23.568ZM40.2641 0.610001L0.610083 40.264C0.250397 40.6616 0.0572984 41.1823 0.0707243 41.7183C0.0841503 42.2544 0.303073 42.7647 0.682216 43.1439C1.06136 43.523 1.57172 43.7419 2.10774 43.7554C2.64376 43.7688 3.16443 43.5757 3.56208 43.216L43.2161 3.562C43.5758 3.16435 43.7689 2.64367 43.7554 2.10765C43.742 1.57163 43.5231 1.06128 43.144 0.682134C42.7648 0.302991 42.2545 0.0840683 41.7184 0.0706423C41.1824 0.0572164 40.6617 0.250315 40.2641 0.610001Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_2332_1851">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
